/**
 * Generate models with NSwagStudio: https://github.com/RSuter/NSwag/wiki/NSwagStudio
 * Make sure to point at the docs url in the top green header
 * IE http://localhost:57462/swagger/docs/v1
 * NOT http://localhost:57462/swagger/ui/index#/

 Config Options:
  - Set namespace to Models
  - TS version 2.7
  - Generate DTO types: Checked
  - Type Style: Interface
  - Null Value: Null
  - Leave everything else blank or unchecked here
 */

export module Models {
  // manually added, should replace with NSwag Studio output in the future
  export interface PurchaseProfileFormAdd {
    purchaseProfileID?: number;
    profileName: string;
    OwnershipType?: string;
    IndividualContractName?: string;
    CompanyName?: string;
    CompanyRepName?: string;
    CompanyRepName_2?: string;
    JointName1?: string;
    JointName2?: string;
    JointName3?: string;
    JointName4?: string;
    JointName5?: string;
    JointName6?: string;
    MarriedName1?: string;
    MarriedName2?: string;
    OccupancyStatus?: string;
    FundingType?: string;
    FinanceType?: string;
    FinanceDownAmount?: string;
    FinanceLenderPrequalified?: number;
    FinanceLenderCompanyName?: string;
    FinanceLenderContactName?: string;
    FinanceLenderAddress1?: string;
    FinanceLenderAddress2?: string;
    FinanceLenderCity?: string;
    FinanceLenderState?: string;
    FinanceLenderZip?: string;
    FinanceLenderContactPhone?: string;
    FinanceLenderContactPhoneExt?: string;
    FinanceLenderContactFax?: string;
    FinanceLenderContactEmail?: string;
    TitleCompanyName?: string;
    TitleCompanyAddress1?: string;
    TitleCompanyAddress_2?: string;
    TitleCompanyCity?: string;
    TitleCompanyState?: string;
    TitleCompanyZip?: string;
    TitleCompanyContactName?: string;
    TitleCompanyContactPhone?: string;
    TitleCompanyContactPhoneExt?: string;
    TitleCompanyContactFax?: string;
    TitleCompanyContactEmail?: string;
    BuyerAgentCompanyName?: string;
    BuyerAgentName?: string;
    BuyerAgentAddress1?: string;
    BuyerAgentAddress2?: string;
    BuyerAgentCity?: string;
    BuyerAgentState?: string;
    BuyerAgentZip?: string;
    BuyerAgentPhone?: string;
    BuyerAgentPhoneExt?: string;
    BuyerAgentFax?: string;
    BuyerAgentEmail?: string;
    Other_lender_type?: string;
    BuyerAgentCell?: string;
    havebuyeragent?: number;
    rep_agency?: number;
  }

  export interface PurchaseProfileViewResponse {
    PURCHASEPROFILEID: number;
    PROFILENAME: string;
    OWNERSHIPTYPE: string;
    INDIVIDUALCONTRACTNAME: string;
    COMPANYNAME: string;
    COMPANYREPNAME: string;
    COMPANYREPNAME_2: string;
    JOINTNAME1: string;
    JOINTNAME2: string;
    JOINTNAME3: string;
    JOINTNAME4: string;
    JOINTNAME5: string;
    JOINTNAME6: string;
    MARRIEDNAME1: string;
    MARRIEDNAME2: string;
    OCCUPANCYSTATUS: string;
    FUNDINGTYPE: string;
    FINANCETYPE: string;
    FINANCEDOWNAMOUNT: string;
    FINANCELENDERPREQUALIFIED: string;
    FINANCELENDERCOMPANYNAME: string;
    FINANCELENDERCONTACTNAME: string;
    FINANCELENDERADDRESS1: string;
    FINANCELENDERADDRESS2: string;
    FINANCELENDERCITY: string;
    FINANCELENDERSTATE: string;
    FINANCELENDERZIP: string;
    FINANCELENDERCONTACTPHONE: string;
    FINANCELENDERCONTACTPHONEEXT: string;
    FINANCELENDERCONTACTFAX: string;
    FINANCELENDERCONTACTEMAIL: string;
    TITLECOMPANYNAME: string;
    TITLECOMPANYADDRESS1: string;
    TITLECOMPANYADDRESS_2: string;
    TITLECOMPANYCITY: string;
    TITLECOMPANYSTATE: string;
    TITLECOMPANYZIP: string;
    TITLECOMPANYCONTACTNAME: string;
    TITLECOMPANYCONTACTPHONE: string;
    TITLECOMPANYCONTACTPHONEEXT: string;
    TITLECOMPANYCONTACTFAX: string;
    TITLECOMPANYCONTACTEMAIL: string;
    BUYERAGENTCOMPANYNAME: string;
    BUYERAGENTNAME: string;
    BUYERAGENTADDRESS1: string;
    BUYERAGENTADDRESS2: string;
    BUYERAGENTCITY: string;
    BUYERAGENTSTATE: string;
    BUYERAGENTZIP: string;
    BUYERAGENTPHONE: string;
    BUYERAGENTPHONEEXT: string;
    BUYERAGENTFAX: string;
    BUYERAGENTEMAIL: string;
    OTHER_LENDER_TYPE: string;
    BUYERAGENTCELL: string;
    HAVEBUYERAGENT: number;
    REP_AGENCY: number;
    USECLOSER: string;
  }

  export interface PurchaseProfileRequest {
    PURCHASEPROFILEID: number;
  }

  export interface PurchaseProfile {
    DATECREATED: string;
    OWNERSHIPTYPE: string;
    PURCHASEPROFILEID: number;
    PURCHASEPROFILENAME: string;
  }

  export type PurchaseProfileList = {
    PURCHASEPROFILEDATE: string;
    PURCHASEPROFILENAME: string;
    PURCHASEPROFILEOWNERSHIPTYPE: string;
    PURCHASEPROFILEID: number;
  }[];

  export interface PurchaseProfileListItem {
    PURCHASEPROFILEDATE: string;
    PURCHASEPROFILENAME: string;
    PURCHASEPROFILEOWNERSHIPTYPE: string;
    PURCHASEPROFILEID: number;
  }

  export interface PurchaseProfileDocumentType {
    DOCUMENTTYPEID: number;
    DOCUMENTDESCRIPTION: string;
  }

  export interface PurchaseProfileFinanceType {
    ID: string;
    FINANCETYPE: string;
  }

  export interface PurchaseProfilePurchaseType {
    ID: string;
    PURCHASETYPE: string;
  }

  export interface PurchaseProfileDocsGetResponse {
    FILEID: number;
    DOCUMENT_DESCRIPTION: string;
    DOCUMENT_FILE_NAME: string;
    DATE_UPLOADED: string;
    FILE_URL: string;
  }

  export const SearchRouteSlug = 'houses-for-auction';
  export const HomePageDummySlug = 'home-page';
  export const SearchRouteMobileSlug = 'mobile/save-search/saved/';
  export const BuySellMobileSlug = 'mobile/buy-sell';

  export interface SortOptions {
    name: string;
    code: keyof Models.PropertySearchResponse | null;
    desc?: true;
  }

  export interface Auth {
    data: {
      userGuid: string;
      token: string;
      expires?: string;
      expirationSeconds?: number;
    };
    success: boolean;
    meta: { requestTraceId: string };
  }
  export interface User {
    id: number;
    name?: string;
    firstName?: string;
    lastName?: string;
    username: string;
    email?: string;
    address?: {
      street?: string;
      suite?: string;
      city?: string;
      zipcode?: string;
      geo?: {
        lat?: string;
        lng?: string;
      };
    };
    phone?: string;
    website?: string;
    company?: {
      name?: string;
      catchPhrase?: string;
      bs?: string;
    };
  }

  export interface PhotoPaths {
    previewImageSrc: string;
    thumbnailImageSrc?: string;
    alt?: string;
    title?: string;
    index: number;
  }

  export interface QueryParamsSearchFilters {
    CATEGORYLIST?: number[] | null;
    TYPE?: any | null;
    MINBEDS?: number | null;
    MINBATHS?: number | null;
    // ADDITIONAL OPTIONS
    MORE?: {
      FINANCING?: boolean[] | null;
      OCCUPANCY?: string[] | null;
      RESERVEMET?: boolean | null;
      ENDINGTODAY?: boolean | null;
      NOBUYERPREMIUMS?: boolean | null;
      POSTAUCTIONS?: boolean | null;
    };
  }

  export interface SearchPageQueryParams {
    filters?: QueryParamsSearchFilters;
    pagination: { page: number };
    map?: {
      viewportBounds?: google.maps.LatLngBoundsLiteral;
      zoom?: number;
      center?: google.maps.LatLng | null | google.maps.LatLngLiteral;
    };
    search?: {
      term?: string;
      placeId?: string;
    };
    contentView: 'searchResults' | 'savedSearches';
    sortDirection?: 'asc' | 'desc';
    mobileListingsVisible?: boolean;
  }

  interface PropertyListingBase {
    property_id: number;
    display_lat: number;
    display_lng: number;
    display_address: string;
    city: string;
    county: string;
    state: string;
    zip_code: number;
    agent_name: string;
    office_name: string;
    listing_office_name: string;
    listing_price: string;
    total_bedrooms: number;
    total_bathrooms: number;
    is_single_family: string;
    is_multi_family: string;
    is_condo: string;
    is_condo_townhouse: string;
    is_townhouse: string;
    is_lot: string;
    square_feet: number;
    days_on_market: number;
    lot_dimension: string;
    hoa_fee: string;
    year_built: number;
    listing_status: string;
    listing_status_standardized: string;
    photo_url: string;
    thumbnail_url: string;
    photos: string;
    metadata: {
      title: string;
      description: string;
      iconClass: string;
      isBrand: true;
    };
    latitude: number;
    longitude: number;
  }

  export enum AuctionType {
    // These need to convert to abbreviations to match backend and be deleted
    OnlineTraditional = 'OnlineTraditional',
    OnlineForeclosure = 'OnlineForeclosure',
    OnlineReo = 'OnlineReo',
    CountyOnlineForeclosure = 'CountyOnlineForeclosure',
    OnlineCwcot = 'OnlineCwcot',
    LiveForeclosure = 'LiveForeclosure',

    RE = 'RE', // OnlineReo = 'OnlineReo', ??
    BD = 'BD',
    RL = 'RL', // LiveForeclosure = 'LiveForeclosure', ??
  }

  export enum SearchPropertyType {
    NotSpecified = 'NotSpecified',
  }

  export enum BidType {
    ActiveAuction = 1,
    PreAuction,
    PostAuction,
  }

  export enum MyListingsAuctionStatuses {
    UPCOMING = 'Upcoming',
    ACTIVE_AUCTION = 'Active Auction',
    POST_AUCTION = 'Post Auction',
    SOLD = 'Sold',
    RETURNED = 'Returned',
  }

  export const PROPERTY_STATUS_COLOR: Record<string, string> = {
    [MyListingsAuctionStatuses.SOLD]: '#419544',
    [MyListingsAuctionStatuses.ACTIVE_AUCTION]: '#1C80CF',
    [MyListingsAuctionStatuses.UPCOMING]: '#D06900',
    [MyListingsAuctionStatuses.RETURNED]: '#C61A54',
    [MyListingsAuctionStatuses.POST_AUCTION]: '#B08620',
  };

  /** Extended data mock to include covius listing info */
  export interface PropertyListing extends PropertyListingBase {
    type: AuctionType;
    auction_date: string | Date;
    images: string[];
    saved: boolean;
    num_saved: number;
    price: number;
  }

  export interface DropdownOption {
    label: string;
    value: string;
    selected?: boolean;
  }

  export interface DropdownGroupedOptions {
    subTitle?: string;
    options: DropdownOption[];
  }

  export interface MenuItem {
    label: string;
    routerLink?: string;
    routerMobile?: string;
    routerLinkActiveOptions?: any;
    command?: () => any;
    externalLink?: string;
    state?: any;
  }

  export interface MenuItemGroup {
    label: string;
    menuItems: MenuItem[];
  }

  export interface PropertyStatusEnum {
    statusid: number;
    statusname: string;
  }

  export interface AddBidDepositRequest {
    CUSTOMER_ID?: string;
    DATADESCRIPTOR?: string;
    DATAVALUE?: string;
  }

  export interface BuyerAgentRequest {
    CONTACT_FIRST_NAME?: string;
    CONTACT_LAST_NAME?: string;
    EMAIL?: string;
    COMPANY_FAX?: string;
    MOBILE?: string;
    ADDRESS1?: string;
    CITY?: string;
    STATE?: string;
    POSTAL_CODE?: string;
    COMPANY_NAME?: string;
    COMPANY_ADDRESS1?: string;
    COMPANY_ADDRESS2?: string;
    COMPANY_CITY?: string;
    COMPANY_STATE?: string;
    COMPANY_POSTAL_CODE?: string;
  }

  /********************************
   *  BEGIN NSWAG STUDIO COPY/PASTE
   ********************************/
  /* tslint:disable */
  /* eslint-disable */
  //----------------------
  // <auto-generated>
  //     Generated using the NSwag toolchain v13.1.6.0 (NJsonSchema v10.0.28.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
  // </auto-generated>
  //----------------------
  // ReSharper disable InconsistentNaming

  export interface AddAgentContactRequest {
    DISPLAYNAME?: string;
    CONTACT_First_Name?: string;
    CONTACT_Last_Name?: string;
    Password?: string;
    Password_Confirmation?: string;
    Agent_ID?: number;
    AGENT_ID?: number;
    Agent_Type_ID?: number;
    Company_Code?: string;
    Company_Name?: string;
    Automate_Signs?: string;
    Automate_Verify?: string;
    Default_Commission?: string;
    Seller_Type_ID?: number;
    Name_On_Contract?: string;
    Seller_Contract_Contact?: string;
    Seller_Contract_Recipient?: string;
    Remove_No_Bids?: string;
    Remove_Post_Auction?: string;
    Managing_Broker?: string;
    Contract_Return_Timeframe?: string;
    Company_Name_Verified?: string;
    Contact_Name_Verified?: string;
    Escrow_Verified?: string;
    Facilitate_BS_Verified?: string;
    Close_By_Mail_Cash_Verified?: string;
    Close_By_Mail_Finance_Verified?: string;
    Accept_Money_Order?: string;
    Licensed_States_Verified?: string;
    Title_Rates_Obtained?: string;
    Investory_Affilate_ID?: number;
    Contact_Name?: string;
    Phone1?: string;
    Phone2?: string;
    Mobile?: string;
    Fax?: string;
    Email?: string;
    Address1?: string;
    Address2?: string;
    City?: string;
    State?: string;
    Postal_Code?: string;
    Phone1_Ext?: string;
    Phone2_Ext?: string;
    Website?: string;
    AMS_Text_Optin?: string;
    Rating?: string;
    Comments?: string;
    Master_Seller?: string;
    Seller_ID?: number;
    Status_Ind?: string;
    Agree_Terms?: string;
    Developer?: string;
    User_Name?: string;
    Fee_Amt?: number;
    Upload_Fee_Applies?: string;
    Contact_Photo?: string;
    Original_Location?: string;
    Listing_Agent_ID?: number;
    Customer_ID?: string;
    Seller_Team?: string;
    License_Number?: string;
    License_State?: string;
    Email2?: string;
    Email3?: string;
    Job_Title?: string;
    Primary_Use?: string;
    Send_Marketing_Emails?: string;
    Title_Fee_Requests?: string;
    Send_Me_Texts?: string;
    Commercial?: string;
    Company_Address1?: string;
    Company_Address2?: string;
    Company_City?: string;
    Company_State?: string;
    Company_Postal_Code?: string;
    Company_Phone1?: string;
    Company_Phone2?: string;
    Company_Phone1_Ext?: string;
    Company_Phone2_Ext?: string;
    Company_Fax?: string;
  }

  export interface AgentBiddingResponse {
    CUSTOMER_ID?: string;
    FIRST_NAME?: string;
    LAST_NAME?: string;
    HANDLE_ID?: string;
    ITEM_ID?: number;
    ADDRESS1?: string;
    CITY?: string;
    STATE?: string;
    POSTAL_CODE?: string;
    STATUS_ID?: string;
    AUCTION_END_DATE?: string;
    AUCTION_START_DATE?: string;
    FINAL_RESERVE?: string;
    BID_AMT?: string;
    BID_DATE?: string;
    BID_ASSIST_AMT?: string;
    BID_CNT?: string;
    HIGH_BIDDER?: string;
    HIGH_OFFER?: string;
    CURR_DATE?: string;
  }

  export interface BidderRequest {
    REP_CONTACT_ID?: number;
    BUYER_CONTACT_ID?: number;
    STATUS_IND?: string;
    FIRST_NAME?: string;
    LAST_NAME?: string;
    MID_INITIAL?: string;
    HANDLE_ID?: string;
    PASSWORD_CODE?: string;
    EMAIL_ADDR?: string;
    COMPANY_NAME?: string;
    TAX_ID?: string;
    BILL_ADDR_1?: string;
    BILL_ADDR_2?: string;
    BILL_CITY?: string;
    BILL_STATE_CODE?: string;
    BILL_POSTAL_CODE?: string;
    BILL_COUNTRY?: string;
    DAY_PHONE_NUM?: string;
    DAY_PHONE_EXT?: string;
    EVE_PHONE_NUM?: string;
    FAX_PHONE_NUM?: string;
    PAYMENT_TYPE?: string;
    CREDIT_CARD_NAME?: string;
    CREDIT_CARD_NUM?: string;
    CREDIT_CARD_EXP_DATE?: string;
    SHIP_ADDR_1?: string;
    SHIP_ADDR_2?: string;
    SHIP_CITY?: string;
    SHIP_STATE_CODE?: string;
    SHIP_POSTAL_CODE?: string;
    SHIP_COUNTRY?: string;
    INFO_SOURCE_DESC?: string;
    OTHER_SOURCE_DESC?: string;
    AGREE_TERMS_IND?: string;
    JOIN_DATE?: Date;
    BANK_IND?: string;
    DRIVER_LIC_NUM?: string;
    DRIVER_LIC_STATE_CODE?: string;
    DRIVER_LIC_EXP_DATE?: string;
    BROKER_AGENT_NAME?: string;
    BROKER_COMPANY?: string;
    BROKER_AGENT_PHONE?: string;
    BROKER_AGENT_EMAIL?: string;
    CELL_PHONE?: string;
    BUYER_NOTE?: string;
    CONTACT_ON_PROPERTY?: string;
    AGENT_CONTACT_ID?: string;
    DEFAULT_LANGUAGE?: string;
    ACH_BANK?: string;
    ACH_TRANSIT_ROUTING?: string;
    ACH_ACCOUNT?: string;
    RATING?: string;
    COMMENTS?: string;
    SHIP_ATTENTION?: string;
    SHIP_COMPANY?: string;
    BROKER_AGENT_FAX?: string;
    LAST_UPDATE?: Date;
    LENDING_CONTACT_ID?: string;
    ORGANIZATION_DOCS?: string;
    SEND_MARKETING_EMAILS?: boolean | string;
    RECEIVE_TEXTS?: boolean | string;
    DEPOSIT_EXEMPT?: string;
  }

  export interface ContactUsRequest {
    Name: string;
    Phone?: string;
    Email: string;
    Comments?: string;
    Token?: string;
    Department: number;
  }

  export interface ListAgentResponse {
    AGENT_ID: number;
    AGENT_TYPE_ID: number;
    COMPANY_CODE: string;
    COMPANY_NAME: string;
    PHONE1: string;
    PHONE2: string;
    FAX: string;
    ADDRESS1: string;
    ADDRESS2: string;
    CITY: string;
    STATE: string;
    POSTAL_CODE: string;
    PHONE1_EXT: string;
    PHONE2_EXT: string;
    AUTOMATE_SIGNS: string;
    AUTOMATE_VERIFY: string;
    SELLER_TYPE_ID: number;
    REMOVE_NO_BIDS: number;
    REMOVE_POST_AUCTION: number;
    ESCROW_VERIFIED: string;
    LICENSE_NUMBER: string;
    LICENSED_STATES_VERIFIED: string;
    TITLE_RATES_OBTAINED: string;
    STATUS_IND: string;
  }

  export interface LoginRequest {
    // Username: string;
    Email: string;
    Password: string;
  }

  export interface ListContactsResponseContact {
    AGENT_CONTACT_ID: number;
    AGENT_ID?: number;
    AGENT_TYPE_ID?: number;
    COMPANY_CODE?: string;
    COMPANY_NAME?: string;
    AGENT_PHONE1?: string;
    AGENT_PHONE2?: string;
    AGENT_FAX?: string;
    AGENT_ADDRESS1?: string;
    AGENT_ADDRESS2?: string;
    AGENT_CITY?: string;
    AGENT_STATE?: string;
    AGENT_POSTAL_CODE?: string;
    CONTACT_ID?: number;
    CONTACT_NAME?: string;
    CONTACT_PHONE1?: string;
    CONTACT_PHONE2?: string;
    CONTACT_MOBILE?: string;
    CONTACT_FAX?: string;
    EMAIL?: string;
    CONTACT_ADDRESS1?: string;
    CONTACT_ADDRESS2?: string;
    CONTACT_CITY?: string;
    CONTACT_STATE?: string;
    CONTACT_POSTAL_CODE?: string;
    AGENT_PHONE1_EXT?: string;
    AGENT_PHONE2_EXT?: string;
    CONTACT_PHONE1_EXT?: string;
    CONTACT_PHONE2_EXT?: string;
    CONTACT_RATING?: string;
    AGENT_RATING?: string;
    AUTOMATE_SIGNS?: string;
    AUTOMATE_VERIFY?: string;
    SELLERTYPEID?: number;
    REMOVE_NO_BIDS?: number;
    REMOVE_POST_AUCTION?: number;
    CONTACT_PHOTO?: string;
    DEFAULT_COMMISSION?: number;
    NAME_ON_CONTACT?: string;
    USER_NAME?: string;
    MASTER_SELLER?: string;
    SELLER_ID?: string;
    MANAGING_BROKER?: string;
    STATUS_ID?: string;
    JOIN_DATE?: Date;
    UPLOAD_FEE_APPLIES?: string;
    CONTRACT_RETURN_TIMEFRAME?: string;
    AGENT_STATUS?: string;
    CONTACT_STATUS?: string;
    LISTING_AGENT_ID?: number;
    AGENT_CUSTOMER_ID?: string;
    SELLER_TEAM?: string;
    COMPANY_NAME_VERIFIED?: string;
    CONTACT_NAME_VERIFIED?: string;
    ESCROW_VERIFIED?: string;
    FACILITATE_BS_VERIFIED?: string;
    CLOSE_BY_MAIL_CASH_VERIFIED?: string;
    CLOSE_BY_MAIL_FINANCE_VERIFIED?: string;
    VERIFIED_DATE?: Date;
    LICENSE_NUMBER?: string;
    LICENSE_STATE?: string;
    EMAIL2?: string;
    EMAIL3?: string;
    COMMENTS?: string;
    SEND_MARKETING_EMAILS?: 'Y' | 'N';
    ACCEPT_MONEY_ORDER?: string;
    LICENSED_STATES_VERIFIED?: string;
    TITLE_RATES_OBTAINED?: string;
  }

  export interface ListCustomersResponseCustomers {
    CUSTOMER_ID?: string;
    FIRST_NAME?: string;
    LAST_NAME?: string;
    EMAIL_ADDR?: string;
    CELL_PHONE?: string;
    DAY_PHONE_NUM?: string;
    HANDLE_ID?: string;
    ITEM_ID?: number;
    ADDRESS1?: string;
    CITY?: string;
    STATE?: string;
    POSTAL_CODE?: string;
    STATUS_ID?: number;
    NEWCUSTOMERID?: number;
  }

  export interface LoginResponse {
    DisplayName?: string;
    Email: string;
    HasClientPortalAccess?: boolean;
    Name: string;
    UserType: UserType;
    CustomerID?: string;
  }

  export interface PropertyBidHistoryResponse {
    CUSTOMERID?: string;
    BIDAMOUNT?: number;
    BIDASSISTAMOUNT?: number;
    BIDTYPEID?: number;
    BIDDATE?: Date;
    BIDASSISTDATE?: Date;
    HANDLEID?: string;
  }

  export interface AcceptDisclosureRequest {
    ITEM_ID: number;
    CUSTOMER_ID?: string;
  }

  export interface PropertyCurrentBidResponse {
    CURRENT_BID?: number;
    LEADERBIDDER?: string;
    RESERVE_MET?: string;
    BID_INCREMENT?: number;
    BID_ASSIST?: string;
    AUCTION_END_DATE?: string;
    AUCTION_START_DATE?: string;
    POST_AUCTION_END_DATE?: string;
    SOLD_DATE?: string;
    POSTPONEMENT_DATE?: string;
    CANCELLED_SALE_DATE?: string;
    DATE_END?: string;
    TIMELINE_STATUS?: string;
    STATUS_ID?: PropertyStatusType;
    SALE_LOCATION?: string;
  }

  export interface PropertyLookup {
    PROP_TYPE_DESC: string;
    STATUS_ID: number;
    PARCEL_ID: string;
    BATH_COUNT: number;
    STATE: string;
    AUCTION_START_DATE: string;
    POST_AUCTION_END_DATE: string;
    CATEGORY_ONLINE_DESCRIPTION: string;
    APPRAISAL_OPINION_OF_VALUE: number;
    POSTAL_CODE: string;
    BPO_VALUE: number;
    BEDROOM_COUNT: number;
    ADDRESS1: string;
    TYPE: number;
    PHOTOS: PropertyDetailsResponsePhotoInfo[];
    ADDRESS2: string;
    COUNTY: string;
    CATEGORY_ONLINE_HINT_TEXT: string;
    AUCTION_TYPE: string;
    ASSET_VALUE: number;
    AUCTION_END_DATE: string;
    CATEGORYID: number;
    ITEM_ID: number;
    CITY: string;
    SQ_FT: number;
    PROPERTY_ID: number;
    ESTIMATEDVALUE: number;
    DATE_END: string;
    LAT: number;
    LONG: number;
    CURRENT_HIGH_BIDDER: string;
    CURRENT_HIGH_BID: number;
  }

  export interface PropertyDetailsResponse {
    ACRES?: string;
    ADDRESS1?: string;
    ADDRESS2?: string;
    ADDRESSLINE?: string;
    AUCTION_END_DATE?: string;
    AUCTION_START_DATE?: string;
    BASEMENT?: string;
    BASEMENTFINISHED?: string;
    BATH_COUNT?: number;
    BEDROOM_COUNT?: number;
    BIDDINGINSTRUCTIONS?: string;
    CATEGORY_ONLINE_DESC?: string;
    CATEGORY_ONLINE_HINT_TEXT?: string;
    CATEGORYID?: number;
    CITY?: string;
    CLOSING_INFORMATION?: {
      CLOSING_DEPOSIT: number;
      PURCHASE_PRICE: number;
      SOLDDATE?: string;
    };
    COLLATERALDESCRIPTION?: string;
    COUNTRY?: string;
    COUNTY?: string;
    CURRENT_ONLINE_AUCTION_BID_INFORMATION?: {
      BIDAMT?: number;
      BIDASSISTAMT?: number;
      BIDDATE?: Date;
      CUSTOMERID?: string;
      HANDLEID?: string;
    };
    DATE_END?: string;
    DEPOSIT?: string;
    FINALRESERVE?: number;
    FIREPLACE?: string;
    FORCLOSURE_ONLINE_AUCTIONS?: {
      FIRST_AUCTION_END_TIME?: string;
      SECOND_AUCTION_START_DATE?: string;
      FIRSTCHANCEAUCTION_STATUS_ID?: number;
      SHERIFF_APPRAISED_VALUE?: number;
      SECOND_AUCTION_END_TIME?: string;
      FIRST_AUCTION_START_DATE?: string;
      FIRST_PUB_DATE?: string;
      FIRST_AUCTION_END_DATE?: string;
      SECOND_AUCTION_START_TIME?: string;
      CREDIT_BID?: number;
      CASENUMBER?: string;
      SECOND_AUCTION_END_DATE?: string;
      FIRST_AUCTION_START_TIME?: string;
      CANCELLEDSALEUPDATED?: string;
      THIRD_PUB_DATE?: string;
      SECOND_PUB_DATE?: string;
      OPENING_BID?: number;
    };
    GARAGESIZE?: number;
    HALFBATH?: string;
    HEATTYPE?: string;
    HIGHLIGHTS?: string;
    HOADUESDUE?: number;
    ITEM_ID: number;
    ITEMDESC?: string;
    ITF?: string;
    LAT?: number;
    LIVE_FORCLOSURE?: {
      SALELOCATION?: string;
      SALERESULT?: string;
      SALEWINNINGBID?: number;
      SALEDATEORIGINAL?: string;
      SALEDATE?: string;
      POSTPONEMENT_DATE?: string;
      CANCELLED_SALE_DATE?: string;
      SALEOPENINGBID?: string;
      APPRAISEDVALUE?: number;
      SALETIME?: string;
      TRUSTEESTARTINGBID?: number;
      SALETIMEEND?: string;
    };
    LONG?: number;
    OCCUPIEDPROPERTY?: string;
    OPENHOUSE1?: string;
    OPENHOUSE2?: string;
    PARCEL_ID?: string;
    PARTICIPANTS?: PropertyDetailsResponseParticipantsType;
    PHOTOS?: PropertyDetailsResponsePhotoInfo[];
    POST_AUCTION_END_DATE?: string;
    POSTAL_CODE?: string;
    PREAUCTION_START_DATE?: string;
    PROGRAMID?: number;
    PROP_TYPE_DESC?: string;
    PROPERTY_TYPE_DESC?: string;
    PROPERTYNAME?: string;
    PROPERTYOWNER?: string;
    SELLERID?: number;
    SPECIALINFO?: string;
    SQ_FT?: number;
    STATE?: string;
    STATENAME?: string;
    STATUS_ID?: number;
    SUBDIVISION?: string;
    TAXESDUE?: number;
    TRUSTEENUMBER?: string;
    VALUE?: number;
    VTURL?: string;
    YEARBUILT?: number;
    METROCODE?: number;
    METROTITLE?: string;
    ESTIMATEDVALUE?: number;
    FOXYAIPDF?: string;
  }

  /*
   * Numeric value maps to CATEGORYID on a Property
   * Values derived from GET /public/types/sale
   */
  export enum PropertyCategoryType {
    ONLINE_AUCTION_REO = 1,
    ONLINE_AUCTION_CWCOT = 2,
    LIVE_FORECLOSURE_SALES = 3,
    ONLINE_FORECLOSURE_SALES = 4,
    AUCTIONS_COMING_SOON = 5,
    LOCAL_COUNTY_ONLINE_FORECLOSURE_SALES = 6,
    ONLINE_AUCTIONS_TRADITIONAL = 7,
    MARKET_LISTING = 8,
  }

  export enum PropertyStatusType {
    SOLD = 1,
    AVAILABLE = 2,
    PENDING = 3,
    WITHDRAWN = 8,
    IN_NEGOTIATIONS = 9,
    RETURNED = 15,
    REMARKET = 50,
  }

  export const AUCTION_TYPE_DESCRIPTION_BY_CAT: Record<string, string> = {
    '1': 'Online - REO',
    '2': 'Online Auctions - CWCOT',
    '3': 'Live Foreclosure',
    '4': 'Online Foreclosure',
    '5': 'Auction Coming Soon',
    '6': 'County Online Foreclosure',
    '7': 'Online - Traditional',
    '8': 'Listings',
  };

  export const AUCTION_TYPE_COLOR_BY_CAT: Record<string, string> = {
    '1': '#00796B', // "Online Auction - REO",
    '2': '#008299', // "Online Auction - CWCOT",
    '3': '#D81B60', // "Live Foreclosure Sales",
    '4': '#5E35B1', // "Online Foreclosure Sales",
    '5': '#D06900', // "Auctions Coming Soon",
    '6': '#BF360C', // "Local County Online Foreclosure Sales",
    '7': '#0277BD', // "Online Auctions - Traditional",
    '8': '#4a8d10', // "Market List Auctions"
  };

  export interface PropertyDetailsResponseParticipantsType {
    LISTINGAGENT?: PropertyDetailsResponseParticipantsTypeListingAgentType;
    BORROWERCONTACT?: PropertyDetailsResponseParticipantsTypeBorrowerContactType;
    BUYINGAGENT?: PropertyDetailsResponseParticipantsTypeBuyingAgentType;
    AUCTIONEER?: PropertyDetailsResponseParticipantsTypeAuctioneerType;
    FORECLOSINGCONTACT: PropertyDetailsResponseParticipantsTypeForeClosingContactType;
    COOPBROKER: PropertyDetailsResponseParticipantsTypeCoopbroker;
  }

  export interface PropertyDetailsResponseParticipantsTypeAuctioneerType {
    SALESPERSONLICENSENO?: string;
    CONTACTNAME?: string;
    COMPANYNAME?: string;
    CITY?: string;
    STATE?: string;
    LICENSESTATE?: string;
    LICENSENO?: string;
    PHONE?: string;
  }

  export interface PropertyDetailsResponseParticipantsTypeBorrowerContactType {
    COMPANYNAME?: string;
    PHONE?: string;
    EMAIL?: string;
  }

  export interface PropertyDetailsResponseParticipantsTypeBuyingAgentType {
    FEE?: string;
  }

  export interface PropertyDetailsResponseParticipantsTypeListingAgentType {
    CONTACTNAME?: string;
    COMPANYNAME?: string;
    PHOTO?: string;
    EMAILADDRESS?: string;
    PHONE?: string;
  }

  export interface PropertyDetailsResponseParticipantsTypeForeClosingContactType {
    ADDRESS1?: string;
    CITY?: string;
    COMPANYNAME?: string;
    EMAIL?: string;
    PHONE?: string;
    POSTALCODE?: string;
    STATE?: string;
  }

  export interface PropertyDetailsResponseParticipantsTypeCoopbroker {
    CONTACTNAME: string;
    CITY: string;
    LICENSESTATE: string;
    PHONE: string;
    COMPANYNAME: string;
    STATE: string;
    LICENSENO: string;
  }

  export interface PropertyDetailsResponsePhotoInfo {
    IMAGE_PATH?: string;
    IMAGE_DESCRIPTION?: string;
    MAIN?: number;
  }

  export interface PropertyPhotosListResponse {
    PROPERTY_ID: number;
    IMAGE_ID: number;
    IMAGE_PATH: string;
    IMAGE_DESCRIPTION: string;
    MAINIMAGE: boolean;
  }

  export interface PropertyDocumentsListResponse {
    DOCUMENTID: number;
    DISPLAY_NAME: string;
    FILE: string;
    FILE_SIZE: number;
  }

  export interface PropertyFeesResponse {
    FEE: string;
  }

  export interface HolidayCalendarResponse {
    HOLIDAY_DATE: string;
  }

  export interface AuctionTimeLineDates {
    Dates: string;
  }

  export interface AuctionLicenseResponse {
    STATE_CODE: string;
    STATE_NAME: string;
    BROKER_COMPANY_NAME?: string;
    BROKER_COMPANY_LICENSE_TYPE?: string;
    BROKER_COMPANY_LICENSE_NUMBER?: string;
    BROKER_CONTACT_NAME?: string;
    BROKER_LICENSE_NUMBER?: string;
    BROKER_PHONE_NUMBER?: string;
    BROKER_EMAIL_ADDRESS?: string;
    BROKER_MAILING_ADDRESS?: string;
    BROKER_MAILING_CITY?: string;
    BROKER_MAILING_STATE?: string;
    AUCTION_COMPANY_NAME?: string;
    AUCTION_COMPANY_LICENSE_NUMBER?: string;
    AUCTIONEER_NAME?: string;
    AUCTIONEER_LICENSE_NUMBER?: string;
    AUCTIONEER_PHONE_NUMBER?: string;
    AUCTIONEER_EMAIL_ADDRESS?: string;
    AUCTIONEER_MAILING_ADDRESS?: string;
    PRIVATE_SELLING_OFFICER_NAME?: string;
    PRIVATE_SELLING_OFFICER_BROKER_LICENSE_NUMBER?: string;
    PRIVATE_SELLING_OFFICER_BROKER_LICENSE_EXPIRATION_DATE?: string;
    PRIVATE_SELLING_OFFICER_AUCTIONEER_LICENSE_NUMBER?: string;
    PRIVATE_SELLING_OFFICER_AUCTIONEER_LICENSE_EXPIRATION_DATE?: string;
    PRIVATE_SELLING_OFFICER_NOTES?: string;
    PRIVATE_SELLING_OFFICER_PHONE_NUMBER?: string;
    PRIVATE_SELLING_OFFICER_EMAIL_ADDRESS?: string;
    PRIVATE_SELLING_OFFICER_MAILING_ADDRESS?: string;
    PRIVATE_SELLING_OFFICER_CITY?: string;
    PRIVATE_SELLING_OFFICER_STATE?: string;
    PRIVATE_SELLING_OFFICER_POSTAL_CODE?: string;
    PRIVATE_SELLING_OFFICER_FEES?: string;
  }

  export interface PropertySaleTypeResponse {
    CATEGORYID?: number;
    CATEGORYNAME?: string;
    CATEGORYHINT?: string;
    DISPLAYORDER?: number;
  }

  export interface SavedSearch {
    SAVEDSEARCHID: number;
    SEARCHSTRING: string;
    SEARCHNAME: string;
    EMAIL_ACTIVE: boolean;
    TEXT_ACTIVE: boolean;
    CITY: string;
    STATE: string;
    ZIP: string;
    ADDRESS: string;
    COUNTY: string;
  }

  export interface WatchedProperties {
    PROP_TYPE_DESC: string;
    POST_AUCTION_END_DATE: string;
    BATH_COUNT: number;
    STATE: string;
    AUCTION_START_DATE: string;
    CATEGORY_ONLINE_DESC: string;
    STATUS: string;
    APPRAISAL_OPINION_OF_VALUE: string;
    POSTAL_CODE: string;
    BPO_VALUE: number;
    BEDROOM_COUNT: number;
    ADDRESS1: string;
    TYPE: string;
    PHOTOS: Array<{
      IMAGE_PATH: string;
      IMAGE_DESCRIPTION: string;
      MAIN_IMAGE: number;
    }>;
    ADDRESS2: string;
    COUNTY: string;
    CATEGORY_ONLINE_HINT_TEXT: string;
    ASSET_VALUE: number;
    AUCTION_END_DATE: string;
    CATEGORYID: number;
    ITEM_ID: number;
    HIGHEST_BID: number;
    CITY: string;
    HIGH_BIDDER: string;
    SQ_FT: number;
    ESTIMATEDVALUE: number;
    STATUS_ID: PropertyStatusType;
    DATE_END: string;
  }

  export interface MyListing {
    ITEM_ID: number;
    STATUS: string;
    STATUS_ID?: PropertyStatusType;
    DATE_END?: string;
    ADDRESS1: string;
    ADDRESS2: string;
    CITY: string;
    STATE: string;
    POSTAL_CODE: string;
    AUCTION_START_DATE: string;
    AUCTION_END_DATE: string;
    POST_AUCTION_END_DATE: string;
    HIGHEST_BID: number;
    HIGH_BIDDER: string;
    RESERVE: number;
    PROPERTY_ID: number;
    COUNTY: string;
    LIST_PRICE: number;
    CATEGORYID: number;
    Verified: string;
  }

  export interface MyListingVerify {
    ITEM_ID: number;
    STATUS: string;
    STATUS_ID: PropertyStatusType;
    DATE_END: string;
    ADDRESS1: string;
    ADDRESS2: string;
    CITY: string;
    STATE: string;
    POSTAL_CODE: string;
    AUCTION_START_DATE: string;
    AUCTION_END_DATE: string;
    POST_AUCTION_END_DATE: string;
    HIGHEST_BID: number;
    HIGH_BIDDER: string;
    RESERVE: number;
    PROPERTY_ID: number;
    COUNTY: string;
    LIST_PRICE: number;
    CATEGORYID: number;
    Verified: string;
  }

  export interface PropertyTypeResponse {
    PROP_TYPE_CAT_ID?: number;
    TYPE_CAT_DESC?: string;
  }

  export interface PropertySearchRequest {
    CATEGORYLIST?: number[] | null;
    TYPE?: any | null;
    MINBEDS?: number | null;
    MINBATHS?: number | null;
    // ADDITIONAL OPTIONS
    FINANCING?: string | null;
    OCCUPANCY?: string[] | null;
    RESERVEMET?: number | null;
    ENDINGTODAY?: number | null;
    NOBUYERPREMIUMS?: number | null;
    POSTAUCTIONS?: number | null;
  }

  export interface PropertySearchResponse {
    /** Prop_type_desc is the descriptive text for the property type (ie. Single Family Home) and it relates to the Type field in this response that contains the ID of the property type */
    PROP_TYPE_DESC?: string;
    STATUS_ID?: PropertyStatusType;
    PARCEL_ID?: string;
    BATH_COUNT?: number;
    STATE?: string;
    /** Auction_start_date will display either the start of the auction or the live cry sale date, depending on the type of auction. If this field is blank, "TBD" should be displayed on thefront end */
    AUCTION_START_DATE?: string;
    /** Category_Online_description is descriptive text of main category of properties that this listing belongs to. */
    CATEGORY_ONLINE_DESCRIPTION?: string;
    APPRAISAL_OPINION_OF_VALUE?: number;
    POSTAL_CODE?: string;
    BPO_VALUE?: number;
    BEDROOM_COUNT?: number;
    ADDRESS1?: string;
    TYPE?: number;
    PHOTOS?: PropertySearchResponsePhotoInfo[];
    ADDRESS2?: string;
    COUNTY?: string;
    CATEGORY_ONLINE_DESC?: string;
    /** Category_online_hint_text is the descriptive text for the category for any mouse-over hints that are used for the property’s category. */
    CATEGORY_ONLINE_HINT_TEXT?: string;
    /** Auction_type is being depreciated but is still needed for other apps that will utilize this search */
    AUCTION_TYPE?: string;
    ASSET_VALUE?: number;
    AUCTION_END_DATE?: string;
    CATEGORYID?: number;
    /** Item_id is the id of the auction and will be needed to pass to the property details api */
    ITEM_ID?: number;
    CITY?: string;
    SQ_FT?: number;
    PROPERTY_ID?: number;
    /** EstimatedValue should be used as the defacto field to display the Value of the property instead of asset_value, Appraisal_opinion_of_value or bpo_value */
    ESTIMATEDVALUE?: number;
    /** Date_end should be the field used to determine the end date or sale date of a property */
    DATE_END?: string;
    LAT?: number;
    LONG?: number;
    DISTANCE?: number;
    /** TotalRecords will be present for every property and the number will be the same. This represents the total amount of records that exist for the current search */
    TOTALRECORDS?: number;
    SALEOPENINGBID?: number;
    CURRENT_BID?: number;
    CURRENT_HIGH_BIDDER?: string;
    STATUS?: string;
    POST_AUCTION_END_DATE?: string;
    SOLD_DATE?: string;
    // ENDING_SOONEST?: string;
    CANCELLED_SALE_DATE?: string;
    POSTPONEMENT_DATE?: string;
  }

  export interface PropertySearchResponsePhotoInfo {
    IMAGE_PATH?: string;
    IMAGE_DESCRIPTION?: string;
    MAIN_IMAGE?: number;
  }

  export interface PropertySpotlightsResponse {
    /** Prop_type_desc is the descriptive text for the property type (ie. Single Family Home) and it relates to the Type field in this response that contains the ID of the property type */
    PROP_TYPE_DESC?: string;
    PARCEL_ID?: string;
    BATH_COUNT?: number;
    STATE?: string;
    /** Auction_start_date will display either the start of the auction or the live cry sale date, depending on the type of auction. If this field is blank, "TBD" should be displayed on thefront end */
    Auction_start_date?: Date;
    /** Category_Online_description is descriptive text of main category of properties that this listing belongs to. */
    CATEGORY_ONLINE_DESCRIPTION?: string;
    APPRAISAL_OPINION_OF_VALUE?: number;
    POSTAL_CODE?: string;
    BPO_VALUE?: number;
    BEDROOM_COUNT?: number;
    ADDRESS1?: string;
    TYPE?: number;
    PHOTOS?: PropertySpotlightsResponsePhotoInfo;
    ADDRESS2?: string;
    COUNTY?: string;
    /** Category_online_hint_text is the descriptive text for the category for any mouse-over hints that are used for the property’s category. */
    CATEGORY_ONLINE_HINT_TEXT?: string;
    /** Auction_type is being depreciated but is still needed for other apps that will utilize this search */
    AUCTION_TYPE?: string;
    ASSET_VALUE?: number;
    AUCTION_END_DATE?: Date;
    CATEGORYID?: number;
    /** Item_id is the id of the auction and will be needed to pass to the property details api */
    ITEM_ID?: number;
    CITY?: string;
    SQ_FT?: number;
    PROPERTY_ID?: number;
    /** EstimatedValue should be used as the defacto field to display the Value of the property instead of asset_value, Appraisal_opinion_of_value or bpo_value */
    ESTIMATEDVALUE?: number;
    /** Date_end should be the field used to determine the end date or sale date of a property */
    DATE_END?: string;
  }

  export interface PropertySpotlightsResponsePhotoInfo {
    IMAGE_PATH?: string;
    IMAGE_DESCRIPTION?: string;
    MAIN?: number;
  }

  export interface UserDetailsResponse {
    ADDRESS1: string;
    ADDRESS2: string;
    CELLPHONE: string;
    CITY: string;
    COMPANYNAME?: string;
    COMPANYADDRESS1?: string;
    COMPANYADDRESS2?: string;
    COMPANYCITY?: string;
    COMPANYPOSTALCODE?: string;
    COMPANYPHONE?: string;
    COMPANYSTATE?: string;
    COUNTRY: string;
    DISPLAYNAME?: string;
    EMAIL?: string;
    FIRSTNAME: string;
    HASCLIENTPORTALACCESS?: boolean;
    LASTNAME: string;
    LICENSENUMBER?: string;
    LICENSESTATE?: string;
    POSTALCODE: string;
    STATE: string;
    USERTYPE?: string;
  }

  export interface UserPropertiesBidsResponseProperty {
    ADDRESS1?: string;
    ADDRESS2?: string;
    AUCTION_END_DATE?: Date;
    AUCTION_START_DATE?: Date;
    BID_AMT?: number;
    BID_ASSIST_AMT?: number;
    BID_ASSIST_CARRYOVER?: string;
    BID_ASSIST_DATE?: Date;
    BID_DATE?: string;
    BID_INCREMENT_AMT?: number;
    BROKER_AGENT_EMAIL?: string;
    CITY?: string;
    CUSTOMER_ID?: string;
    EMAIL_ADDR?: string;
    HANDLE_ID?: string;
    HIGHEST_BID?: number;
    ITEM_ID?: number;
    LEAD_BIDDER?: string;
    POST_AUCTION_END_DATE?: Date;
    PURCHASEPROFILEID?: number;
    STATE?: string;
    STATUS_DESCRIPTION?: string;
    POSTAL_CODE: string;
    COUNTY?: string;
  }

  interface AddAlertRequest {
    ALERT_TYPE_ID: number;
    SEND_EMAIL: boolean;
    SEND_TEXT: boolean;
    IS_ACTIVE: boolean;
  }

  export interface UpdateAlertRequest extends AddAlertRequest {
    ALERT_ID?: number;
    SAVED_SEARCH_ID?: number;
    UPDATE_ALL?: boolean;
  }

  export interface GetAlertTypesResponse {
    ALERT_TYPE_ID?: number;
    ALERT_TYPE_DESCRIPTION?: string;
    ALERT_CATEGORY_DESCRIPTION?: string;
    ALERT_CATEGORY_ID?: number;
  }

  export interface GetVipLevelsResponse {
    NUMBERPROPERTIESPURCHASED: number;
    AVERAGEPURCHASEPRICE: number;
    TOTALPURCHASEPRICE: number;
    NUMBERPROPSBIDON: number;
    PERCENTOFVALUE: number;
    VIPLEVEL: number;
    PROPERTIESTONEXTLEVEL: number;
  }

  export interface GetAllAlertsResponse {
    ALERT_ID?: number;
    ALERT_TYPE_ID?: number;
    SEND_EMAIL?: boolean;
    SEND_TEXT?: boolean;
  }

  export interface SuccessResponseMessage {
    SUCCESS?: boolean | null;
    MESSAGE?: string | null;
  }

  export interface BidDepositStatus {
    HOLDACTIVE: number;
    DEPOSITHOLDID: number;
    AUTHORIZECUSTOMERID: string;
    AUTHORIZETRANSACTIONID: string;
    HOLDINITIALDATE: string;
    AMOUNT: number;
    HOLDRENEWALDATE: string;
  }

  export interface CustomerBidDepositStatus {
    CUSTOMER_ID: string;
    FIRST_NAME: string;
    LAST_NAME: string;
    HANDLE_ID: string;
    DEPOSITHOLDID: number;
    AUTHORIZECUSTOMERID: string;
    AUTHORIZETRANSACTIONID: string;
    HOLDINITIALDATE: string;
    AMOUNT: number;
    HOLDRENEWALDATE: string;
    HOLDACTIVE: boolean;
  }

  export interface PurchasedProperty {
    ITEM_ID: number;
    ASSET_NUMBER: string;
    ADDRESS1: string;
    ADDRESS2?: string;
    CITY: string;
    STATE: string;
    POSTAL_CODE: string;
    CUSTOMER_ID?: string;
    FIRST_NAME?: string;
    LAST_NAME?: string;
    EMAIL_ADDR?: string;
    SOLD_DATE: Date;
    CLOSING_DATE: Date;
    ACTUAL_CLOSE_DATE: Date;
    PURCHASE_PRICE: number;
  }

  export enum InspectionsType {
    No = 'no',
    Ni = 'ni',
    Cl = 'cl',
    Ic = 'ic',
  }

  export enum YesNoStringType {
    N = 'N',
    Y = 'Y',
  }

  export enum ZeroOneBoolean {
    TRUE = 1,
    FALSE = 0,
  }

  export interface PropertyAddRequest {
    ADDRESS1: string;
    CITY: string;
    STATE_CODE: string;
    POSTAL_CODE: string;
    TYPE: number;
    BEDROOM_COUNT: number;
    BATH_COUNT: number;
    SQ_FT: number;
    LIST_PRICE: number;
    RESERVE_PRICE_AMT: number;
    DESCRIPTION: string;
    CAN_EDIT_DATE?: ZeroOneBoolean.FALSE | ZeroOneBoolean.TRUE;
    BUYER_BROKER_FEE: string | number;
    LISTING_AGENT_FEE: string | number;
    WEBSITE_LINK: string;
    ADDRESS2: string;
    FIREPLACE: YesNoStringType | ' ';
    GARAGE_SIZE: string;
    HEAT_TYPE: string;
    BASEMENT: string;
    HALF_BATH_COUNT: number;
    SUBDIVISION: string;
    BASEMENT_FINISHED: YesNoStringType;
    PROPERTY_OWNER: string;
    FINAL_RESERVE: number;
    REOFFERED_ITEM_ID: number;
    SELLERTYPE: string;
    YEAR_BUILT: number;
    ACRES: string;
    INSPECTIONS: string | number | null;
    PAYMENT: string;
    FINANCING: YesNoStringType;
    CLOSING: string;
    CLOSINGCOST: number;
    // OTHER1: string;
    OTHER2: string;
    OTHER3: string;
    OTHER4: string;
    YARDSIGN: YesNoStringType;
    LISTING_AGENCY: string;
    LISTING_AGENT_FIRST_NAME: string;
    LISTING_AGENT_LAST_NAME: string;
    LISTING_AGENT_USERNAME: string;
    LISTING_AGENT_EMAIL_ADDRESS: string;
    LISTING_AGENT_PHONE: string;
    LISTING_AGENT_ADDRESS1: string;
    LISTING_AGENT_CITY: string;
    LISTING_AGENT_STATE_CODE: string;
    LISTING_AGENT_POSTAL_CODE: string;
    LISTING_AGENT_LICENSE_NUMBER?: string;
    LISTING_AGENT_LICENSE_STATE?: string;
    CLOSER_AGENT_AGENCY: string;
    CLOSER_AGENT_FIRST_NAME: string;
    CLOSER_AGENT_LAST_NAME: string;
    CLOSER_AGENT_EMAIL_ADDRESS: string;
    CLOSER_AGENT_PHONE: string;
    CLOSER_AGENT_ADDRESS1: string;
    CLOSER_AGENT_CITY: string;
    CLOSER_AGENT_STATE_CODE: string;
    CLOSER_AGENT_POSTAL_CODE: string;
    // Added
    CONTINGENCIES: string | number | null;
    HAS_FINANCING_CONTINGENCY: 'N' | 'Y';
    HAS_AN_INSPECTION_CONTINGENCY?: boolean; // ! NOT PART OF ANY ENDPOINTS - USED INTERNALLY
    AUCTION_START_DATE: string;
  }

  export interface PropertyDisplayResponse {
    CAN_EDIT_DATE: ZeroOneBoolean.FALSE | ZeroOneBoolean.TRUE;
    AUCTION_START_DATE: string;
    AUCTION_END_DATE: string;
    POST_AUCTION_END_DATE: string;
    AUCTION_DAY_COUNT: number;
    ADDRESS1: string;
    CITY: string;
    STATE_CODE: string;
    POSTAL_CODE: string;
    TYPE: number;
    BEDROOM_COUNT: number;
    BATH_COUNT: number;
    SQ_FT: number;
    LIST_PRICE: number;
    RESERVE_PRICE_AMT: number;
    DESCRIPTION: string;
    BUYER_BROKER_FEE: number;
    LISTING_AGENT_FEE: number;
    WEBSITE_LINK: string;
    ADDRESS2: string;
    FIREPLACE: string;
    GARAGE_SIZE: string;
    HEAT_TYPE: string;
    BASEMENT: string;
    OCCUPANCY: string;
    HALF_BATH_COUNT: number;
    SUBDIVISION: string;
    BASEMENT_FINISHED: string;
    YEAR_BUILT: number;
    ACRES: number;
    INSPECTIONS: string;
    PAYMENT: string;
    FINANCING: string;
    CLOSING: string;
    CLOSINGCOST: number;
    CONTINGENCIES: string;
    LISTING_AGENCY: string;
    LISTING_AGENT_FIRST_NAME: string;
    LISTING_AGENT_LAST_NAME: string;
    LISTING_AGENT_EMAIL_ADDRESS: string;
    LISTING_AGENT_PHONE: string;
    LISTING_AGENT_ADDRESS1: string;
    LISTING_AGENT_CITY: string;
    LISTING_AGENT_STATE_CODE: string;
    LISTING_AGENT_POSTAL_CODE: string;
    CLOSER_AGENT_AGENCY: string;
    CLOSER_AGENT_FIRST_NAME: string;
    CLOSER_AGENT_LAST_NAME: string;
    CLOSER_AGENT_EMAIL_ADDRESS: string;
    CLOSER_AGENT_PHONE: string;
    CLOSER_AGENT_ADDRESS1: string;
    CLOSER_AGENT_CITY: string;
    CLOSER_AGENT_STATE_CODE: string;
    CLOSER_AGENT_POSTAL_CODE: string;
  }

  export interface PropertyEditRequest {
    PROPERTY_ID: number;
    ADDRESS1?: string;
    ADDRESS2?: string;
    CITY?: string;
    STATE?: string;
    COUNTRY?: string;
    POSTAL_CODE?: string;
    BEDROOM_COUNT?: number;
    BATH_COUNT?: number;
    SQ_FT?: number;
    VALUE?: number;
    COUNTY?: string;
    ACRES?: string;
    YEAR_BUILT?: string;
    FIREPLACE?: YesNoStringType;
    GARAGE_SIZE?: string;
    HEAT_TYPE?: string;
    BASEMENT?: string;
    HALF_BATH?: number;
    SUBDIVISION?: string;
    BASEMENT_FINISHED?: string;
    LONGITUDE?: number;
    LATITUDE?: number;
    ADDRESS_LINE?: string;
    EXTERNAL_CLIENT_NUMBER?: string;
    INVESTOR_NO?: number;
    UPB?: string;
    ESTIMATED_TOTAL_DEBT?: string;
    LOAN_NEXT_DUE_DATE?: string;
    INVESTOR_NAME?: string;
    GEOLOCATION?: string;
    STATUS_ID?: number;
    ASSET_MANAGER_ID?: number;
    ASSET_NUMBER?: number;
    PHOTO_OBTAINED?: string;
    TYPE?: number;
    VERIFIED?: YesNoStringType;
    SPECIAL_INFO?: string;
    FINAL_RESERVE?: number;
    PHOTO_PATH?: string;
    SELLER_CONTACT_ID?: string;
    AMS_SELLER_ID?: number;
    AMS_AUCTION_NO?: number;
    CATEGORY_ID?: number;
    BUYER_BROKER_FEE?: string;
    PROPERTY_OWNER?: string;
    AUCTION_START_DATE?: Date;
    AUCTION_END_DATE?: Date;
    AUCTION_STOP_DATE?: Date;
    AUCTION_DAY_COUNT?: number;
    MIN_BID_AMT?: number;
    RESERVE_PRICE_AMT?: number;
    BID_INCREMENT_AMT?: number;
    ESCROW_AMT?: number;
    DDI_AMT?: number;
    BUYER_PREMIUM?: number;
    PIP_CODE?: string;
    VT_URL?: string;
    FEATURED?: YesNoStringType;
    SEALED_BID?: string;
    BID_BY_ACRE?: string;
    REOFFER?: YesNoStringType;
    SELLER_CLOSING_CONTACT_ID?: string;
    LISTING_AGENT_FEE?: string;
    PROPERTY_OWNER_ID?: string;
    DUTCH_STYLE?: string;
    ASSET_MGT_FEE?: string;
    DAYS_ON_MARKET?: number;
    REMARKET_STARTING_BID?: string;
    TITLE_ORDER_NO?: string;
    EVENT_TYPE?: string;
    LOAN_NUMBER?: string;
    BPO_VALUE?: number;
    TITLE_POLICY_FEE?: number;
    DONT_RETURN_YET?: string;
    REAUCTIONED?: YesNoStringType;
    MI_APPROVAL?: YesNoStringType;
    RETURN_ON_DATE?: string;
    BPO_DATE?: string;
    OCCUPANCY_DATE?: Date;
    NET_OPERATING_INCOME?: string;
    NUM_STORIES?: number;
    NOI_PERIOD?: string;
    OCCUPANCY?: string;
    PARCEL_ID?: string;
    PROPERTY_NAME?: string;
    NUM_BUILDINGS?: number;
    NUM_UNITS?: number;
    OPEN_HOUSE1?: string;
    OPEN_HOUSE2?: string;
    POST_AUCTION_END_DATE?: Date;
    ADDRESS_UNIT?: string;
    APPRAISED_VALUE?: string;
    MI_FLAG?: string;
    HOMEPATH_PROTECTION_FLAG?: string;
    HOMEPATH_RENOVATION_FLAG?: string;
    RECONSIDERATION_FLAG?: string;
    MLS_NUMBER?: string;
    MLS_NUMBER_VERIFIED?: string;
    LAST_MODIFIED_DATE?: string;
    SHOW_ON_SITE?: string;
    SUB_SELLER_ID?: number;
    BIDDIRECT_MIN_OFFER_PERCENT?: string;
    AQUISITION_PRICE?: string;
    OPTION_CONTRACT?: string;
    ADD_MLS?: string;
    MLS_EMAIL?: string;
    MLS_EXP_DATE?: string;
    PROGRAM_ID?: string;
    UPLOADER_TYPE_ID?: string;
    TRUSTEE_NUMBER?: string;
    INTEGRATION_ID?: string;
    LOAN_TYPE?: string;
    REMOVAL_REASON?: string;
    REMOVAL_REASON_OTHER?: string;
    FC_TYPE?: string;
    MIN_FEE_OVERRIDE?: number;
    PERCENT_OVERRIDE?: number;
    CALCULATED_FEE?: number;
    AUCTION_FEE_CONTRIBUTION?: number;
    NET_FEE_DUE?: number;
    ITEM_DESC?: string;
    SIGN_REQUIRED?: string;
  }

  export interface ClosingCostType {
    ID: string;
    CLOSINGCOSTDESCRIPTION: string;
  }

  export interface ExistingAgent {
    AGENT_CONTACT_ID: number;
    CONTACT_FIRST_NAME: string;
    CONTACT_LAST_NAME: string;
  }

  export interface AgentDetails {
    ADDRESS1: string;
    CITY: string;
    COMPANY_ADDRESS1: string;
    COMPANY_ADDRESS2: string;
    COMPANY_CITY: string;
    COMPANY_NAME: string;
    COMPANY_POSTAL_CODE: string;
    COMPANY_STATE: string;
    CONTACT_FIRST_NAME: string;
    CONTACT_LAST_NAME: string;
    EMAIL: string;
    MOBILE: string;
    POSTAL_CODE: string;
    STATE: string;
    LICENSE_NUMBER: string;
    LICENSE_STATE: string;
  }

  export interface DocumentCategories {
    DOC_CATEGORY_ID: string;
    CATEGORY: string;
  }
  export interface ClientDocument {
    ITEMID: string;
    LOANNUMBER: string;
    AGENTID: number;
    ADDRESS: string;
    ADDRESS2: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COUNTY: string;
    USERNAME: string;
    ID: string;
    PATH: string;
    FILE: string;
    DATECREATED: string;
    UPDATED_AT: string;
    CREATED_BY_ID: number;
    PROPERTY_ID: string;
    CREATED_BY_ID_CLIENT: string;
    CATEGORY_ID: string;
    FILENAME: string;
    TYPE: string;
    DESCRIPTION: string;
    ISARCHIVED: string;
    DOWNLOAD_URL: string;
  }

  export interface SessionInfo {
    AGENT_ID: number;
    AT_CLIENT_NAME: string;
    CONTACT_ID: number;
    CONTACT_NAME: string;
    CURRENT_SERVER_TIME: string;
    EMAIL_ADDRESS: string;
    HANDLE_ID: string;
    LOGIN_ID: number;
    PORTAL_ACCESS: number;
    ROLE: string;
    SESSION_EXPIRATION: string;
    TOKEN: string;
  }

  export interface PostAuctionClientReview {
    POSTAUCTIONENDDATE: string;
    RECORDCOUNT: number;
  }

  export interface PostAuctionClientReviewDrilldown {
    ITEMID: number;
    HIGHBIDID: number;
    LOANNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS1: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: any;
    COUNTY: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    POSTAUCTIONENDDATE: string | Date | null;
    CYCLE: number;
    RESERVEPRICEAMT: number;
    HIGHBID: number;
    TOTALDIFFERENCE: number;
    CLIENTRESPONSE: any;
    COUNTERREASON: any;
  }

  export interface PendingRemovalConfirmation {
    REMOVALCONFIRMATIONCYCLETIME: string;
    RECORDCOUNT: number;
  }

  export interface PendingRemovalConfirmationDrilldown {
    ITEMID: number;
    LOANNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS1: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    'AUCTION STATUS': string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: number;
    RESERVEPRICEAMT: number;
    RUNNUMBER: number;
    FCLSALEDATE: string | Date | null;
    REVIEW_REMOVE_DATE: string | Date | null;
    CONTACTONRBI: string;
    REMOVALWITHDRAWALREASON: string;
    REMOVAL_REASON_OTHER: null;
  }

  export interface LockboxIssuesPendingCorrection {
    ASSETLOCKBOXISSUEDATE: string;
    RECORDCOUNT: number;
  }

  export interface LockboxIssuesPendingCorrectionDrilldown {
    ITEMID: number;
    LOANNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS1: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    CLOSINGSTATUS: string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: null;
    RESERVEPRICEAMT: number;
    RUNNUMBER: number;
    FCLSALEDATE: string | Date | null;
    SOLDDATE: string | Date | null;
    LOCKBOXISSUEDATE: string | Date | null;
    LOCKBOXISSUEDESCRIPTION: string;
    CONTRACTPRICE: number;
    CURRENTEMPLOYEE: string;
    REMOVALWITHDRAWALREASON: null;
    LOCK_BOX_ISSUE_IS_RESOLVED_PORTAL: null;
    LOCK_BOX_ISSUE_RESOLUTION_DETAILS: null;
  }

  export interface PendingSellerExecution {
    CONTRACTSENTTSELLERDATE: string;
    RECORDCOUNT: number;
  }

  export interface PendingSellerExecutionDrilldown {
    ADDRESS: string;
    ASSET_MANAGER: string;
    AUCTIONTYPE: string;
    CITY: string;
    CLOSINGSTATUS: string;
    COMPANYNAME: string;
    CONTACTONRBI: string;
    CONTRACTPRICE: number;
    CONTRACTSENTTOSELLER: string | Date | null;
    CWCOTHOLDSTATUS: string;
    FCLSALEDATE: string | Date | null;
    ITEMID: number;
    LOANNUMBER: string;
    REMOVALWITHDRAWALREASON: string;
    RESERVEPRICEAMT: number;
    RUNNUMBER: number;
    SCHEDULEDCLOSINGDATE: string | Date | null;
    SELLERNAME: string;
    SOLDDATE: string | Date | null;
    STATE: string;
    STATUS: string;
    ZIP: string;
  }

  export interface NewContracts {
    NEWCONTRACTS: string;
    RECORDCOUNT: number;
  }

  export interface NewContractsDrilldown {
    ADDRESS: string;
    ASSET_MANAGER: string;
    AUCTIONTYPE: string;
    CITY: string;
    CLOSINGDATE: string | Date | null;
    CLOSINGSTATUS: string;
    COMPANYNAME: string;
    CONTACTONRBI: string;
    CONTRACTNAME: string;
    CONTRACTPRICE: number;
    CONTRACTTOTC: string | Date | null;
    CWCOTHOLDSTATUS: string;
    DEEDAPPROVEDDATE: string | Date | null;
    DEEDRECORDEDDATE: string | Date | null;
    EXECUTED: string | Date | null;
    FCLSALEDATE: string | Date | null;
    HUDAPPROVEDDATE: string | Date | null;
    ITEMID: number;
    LOANNUMBER: string;
    OCCUPANCY: string;
    PROPERTYSTATUS: string;
    REMOVALWITHDRAWALREASON: string;
    RESERVEPRICEAMT: number;
    RUNNUMBER: number;
    SOLDDATE: string | Date | null;
    STATE: string;
    ZIP: string;
  }

  export interface ScheduledClosing {
    SCHEDULEDCLOSINGDATE: string;
    RECORDCOUNT: number;
  }

  export interface ScheduledClosingDrilldown {
    ADDRESS: string;
    ASSET_MANAGER: string;
    AUCTIONTYPE: string;
    CITY: string;
    CLOSINGDATE: string | Date | null;
    CLOSINGSTATUS: string;
    COMPANYNAME: string;
    CONTACTONRBI: string;
    CONTRACTPRICE: number;
    CONTRACTTOTC: string | Date | null;
    CWCOTHOLDSTATUS: string;
    DEEDAPPROVEDDATE: string | Date | null;
    DEEDRECORDEDDATE: string | Date | null;
    FCLSALEDATE: string | Date | null;
    HUDAPPROVEDDATE: string | Date | null;
    ITEMID: number;
    LOANNUMBER: string;
    PROPERTYSTATUS: string;
    REMOVALWITHDRAWALREASON: string;
    RESERVEPRICEAMT: number;
    RUNNUMBER: number;
    SOLDDATE: string | Date | null;
    STATE: string;
    ZIP: string;
  }

  export interface ProvidedReserveNotMatchingCalculated {
    SCHEDULEDSALEDATE: string;
    RECORDCOUNT: number;
  }

  export interface ProvidedReserveNotMatchingCalculatedDrilldown {
    ADDRESS: string;
    ASSETNUMBER: string;
    ASSET_MANAGER: string;
    AUCTIONTYPE: string;
    CALCULATEDRESERVE: number;
    CITY: string;
    COMPANYNAME: string;
    CWCOTHOLDSTATUS: string;
    FCLSALEDATE: string | Date | null;
    ITEMID: number;
    OPENINGBIDAMOUNT: string;
    PROGRAMTYPE: string;
    RBICONTACT: string;
    REMOVALWITHDRAWALREASON: string;
    SOLDDATE: string | Date | null;
    STATE: string;
    ZIP: string;
  }

  export interface MissingReserveOrValuation {
    TYPE: string;
    COUNT: number;
  }

  export interface MissingReserveOrValuationDrilldown {
    ITEMID: number;
    ASSETNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    CLOSINGSTATUS: string;
    PROGRAMTYPE: string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: string;
    RESERVE: string;
    VALUE: string;
    RUNNUMBER: number;
    FCLSALEDATE: string | Date | null;
    SOLDDATE: string | Date | null;
    CONTACTONRBI: string;
    REMOVALWITHDRAWALREASON: string;
  }

  export interface ClosingDeedToBeExecuted {
    ACTUALCLOSINGDATE: string;
    RECORDCOUNT: number;
  }

  export interface ClosingDeedToBeExecutedDrilldown {
    ITEMID: number;
    LOANNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    CLOSINGSTATUS: string;
    RESERVE: number;
    RUNNUMBER: number;
    FCLSALEDATE: string;
    SOLDDATE: string | Date | null;
    CONTRACTPRICE: number;
    ACTUALCLOSEDATE: string | Date | null;
    CONTACTONRBI: string;
    REMOVALWITHDRAWALREASON: string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: string;
  }

  export interface OutstandingLienAndDemand {
    DEMANDRECEIVEDDATE: string;
    RECORDCOUNT: number;
  }

  export interface OutstandingLienAndDemandDrilldown {
    ITEMID: number;
    LOANNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS1: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    CLOSINGSTATUS: string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: string;
    RESERVEPRICEAMT: number;
    RUNNUMBER: number;
    FCLSALEDATE: string | Date | null;
    SOLDDATE: string | Date | null;
    CONTRACTPRICE: number;
    DEMANDRECEIVEDDATE: string | Date | null;
    CONTACTONRBI: string;
    REMOVALWITHDRAWALREASON: string;
  }

  export interface PrelimHudRequiringApproval {
    HUDRECEIVEDDATE: string;
    RECORDCOUNT: number;
  }

  export interface PrelimHudRequiringApprovalDrilldown {
    ITEMID: number;
    LOANNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    CLOSINGSTATUS: string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: string;
    RESERVE: number;
    RUNNUMBER: number;
    SOLDDATE: string | Date | null;
    CONTRACTPRICE: number;
    HUDRECEIVEDDATE: string | Date | null;
    ACTUALCLOSEDATE: string | Date | null;
    CONTACTONRBI: string;
    REMOVALWITHDRAWALREASON: string;
  }

  export interface PendingFundingConfirmation {
    ACTUALCLOSINGDATE: string;
    COUNT: number;
  }

  export interface PendingFundingConfirmationDrilldown {
    ITEMID: number;
    LOANNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    CLOSINGSTATUS: string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: string;
    RESERVE: number;
    RUNNUMBER: number;
    FCLSALEDATE: string | Date | null;
    SOLDDATE: string | Date | null;
    CONTRACTPRICE: number;
    ACTUALCLOSINGDATE: string | Date | null;
    CONTACTONRBI: string;
    REMOVALWITHDRAWALREASON: string;
  }

  export interface OfferCancellation {
    CANCELLATIONDATE: string;
    THECOUNT: number;
  }

  export interface OfferCancellationDrilldown {
    CANCELLATIONDATE: string;
    ITEMID: number;
    LOANNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    CLOSINGSTATUS: string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: string;
    RESERVEPRICEAMT: number;
    RUNNUMBER: number;
    FCLSALEDATE: string | Date | null;
    SOLDDATE: string | Date | null;
    CONTRACTPRICE: number;
    CONTACTONRBI: string;
    REMOVALWITHDRAWALREASON: string;
  }

  export interface ClosingDatePostponement {
    CLOSINGEXTENSIONDATE: string;
    RECORDCOUNT: number;
  }

  export interface ClosingDatePostponementDrilldown {
    ITEMID: number;
    LOANNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    CLOSINGSTATUS: string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: string;
    RESERVEPRICEAMT: number;
    RUNNUMBER: number;
    FCLSALEDATE: string | Date | null;
    SOLDDATE: string | Date | null;
    CONTRACTPRICE: number;
    CLOSINGEXTENSIONDATE: string | Date | null;
    CONTACTONRBI: string;
    REMOVALWITHDRAWALREASON: string;
  }

  export interface PropertyIssue {
    DUETIME: string;
    COUNT: number;
  }

  export interface PropertyIssueDrilldown {
    ITEMID: number;
    ASSETNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    CLOSINGSTATUS: string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: string;
    RESERVEPRICEAMT: number;
    RUNNUMBER: number;
    FCLSALEDATE: string | Date | null;
    SOLDDATE: string | Date | null;
    CONTRACTPRICE: number;
    DUETIME: string | Date | null;
    CONTACTONRBI: string;
    REMOVALWITHDRAWALREASON: string;
  }

  export interface ClosingPending {
    ACTUALCLOSEDATE: string;
    RECORDCOUNT: number;
  }

  export interface ClosingPendingDrilldown {
    ITEMID: number;
    LOANNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    CLOSINGSTATUS: string;
    RESERVE: number;
    RUNNUMBER: number;
    SOLDDATE: string | Date | null;
    CONTRACTPRICE: number;
    ACTUALCLOSEDATE: string | Date | null;
    CONTACTONRBI: string;
    REMOVALWITHDRAWALREASON: string;
    AUCTIONTYPE: string;
    DEEDAPPROVEDBYSELLERDATE: string | Date | null;
    HUDAPPROVEDBYSELLERDATE: string | Date | null;
  }

  export interface TitleIssueInClosing {
    DEMANDRECEIVEDDATE: string;
    RECORDCOUNT: number;
  }

  export interface TitleIssueInClosingDrilldown {
    ITEMID: number;
    ASSETNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COMPANYNAME: string;
    PROPERTYSTATUS: string;
    CLOSINGSTATUS: string;
    AUCTIONTYPE: string;
    CWCOTHOLDSTATUS: string;
    RESERVEPRICEAMT: number;
    RUNNUMBER: number;
    FCLSALEDATE: string | Date | null;
    SOLDDATE: string | Date | null;
    CONTRACTPRICE: number;
    DEMANDRECEIVEDDATE: string | Date | null;
    ISSUEDESCRIPTION: string;
    CONTACTONRBI: string;
    REMOVALWITHDRAWALREASON: string;
  }

  export interface PropertyDetails {
    ITEMID: number;
    RANK_ORDER: number;
    ASSETNUMBER: string;
    ADDRESS: string;
    ADDRESS2: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COUNTY: string;
    PROGRAMTYPENAME: string;
    PROPERTYSTATUS: string;
    REVIEW_REMOVE_DATE: string | Date | null;
    REMOVE_FLAG: boolean;
    REMOVAL_CAUSE: string;
    REMOVAL_REASON_OTHER: string;
    ITEM_ID: number;
    CALCULATEDRESERVE: number;
    RESERVE: number;
    DEEDEDDATE: string | Date | null;
    OPINIONOFVALUE: string;
    SCHEDULEDSALEDATE: string | Date | null;
    CONTRACTPRICE: number;
    OCCUPANCYSTATUS: string;
    AGENT_ID: number;
    HOLD_STATUS: string;
    SECOND_CHANCE_APPROVAL_DATE: string | Date | null;
    SECOND_CHANCE_REMOVE_DATE: string | Date | null;
    CLOSING_DATE: string | Date | null;
    FUNDED_DATE: string | Date | null;
    OFFER_RECEIVED: string | Date | null;
    HUD_APPROVED: string | Date | null;
    SELLER_CONTRIBUTION: number;
    AUCTION_FEE_CONTRIBUTION: number;
    CD_EXEC: string | Date | null;
  }

  export interface PropertyAuction {
    AUCTIONENDDATE: string | Date | null;
    AUCTIONSTARTDATE: string | Date | null;
    CLOSEDATE: string | Date | null;
    COMPANYNAME: string;
    CYCLE: number;
    EVENTID: string;
    FINALRESERVE: number;
    HIGHBID: number;
    LOANNUMBER: string;
    POSTAUCTIONENDDATE: string | Date | null;
    PROGRAMRECORDTYPE: string;
    PROPERTYID: number;
    SOLDSTATUS: number;
    STATUS: string;
  }

  export interface PropertyOffer {
    BID_AMT: number;
    BID_DATE: string | Date | null;
    BID_ID: string;
    CONTRACTCLOSINGDATE: string | Date | null;
    CUSTOMER: string;
    CUSTOMER_ID: string;
    ITEM_ID: number;
    OFFERSTATUS: string;
    SALEDATE: string | Date | null;
  }

  export interface PropertyDocument {
    ADDRESS: string;
    ADDRESS2: string;
    AGENTID: number;
    CITY: string;
    COUNTY: string;
    CREATED_AT: string | Date | null;
    CREATED_BY_ID: number;
    CREATED_BY_ID_CLIENT: any;
    DESCRIPTION: string;
    FILE: string;
    FILENAME: string;
    ID: number;
    ITEMID: number;
    LOANNUMBER: string;
    PATH: string;
    PROPERTY_ID: string;
    STATE: string;
    TYPE: string;
    UPDATED_AT: string | Date | null;
    USERNAME: string;
    ZIP: string;
  }

  export interface AllDocuments {
    ITEMID: number;
    ASSET_MANAGER: string;
    ADDRESS1: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    COUNTY: string;
    FILENAME: string;
    CREATED_AT: string | Date | null;
    UPDATE_AT: string | Date | null;
    USERNAME: string;
    DOWNLOADURL: string;
  }

  export interface PropertyManage {
    ITEM_ID: number;
    ASSETNUMBER: string;
    ASSET_MANAGER: string;
    ADDRESS: string;
    CITY: string;
    STATE: string;
    ZIP: string;
    PROPERTYSTATUS: string;
    PROGRAMTYPENAME: string;
    REVIEW_REMOVE_DATE: string | Date | null;
    REMOVE_FLAG: boolean;
    REMOVAL_CAUSE: null | string;
    REMOVAL_REASON_OTHER: null | string;
  }

  /********************************
   *  END NSWAG STUDIO COPY/PASTE
   ********************************/

  /********************************
   *  BEGIN EXTENDS NSWAG
   ********************************/

  export enum UserType {
    Client = 'Client',
    Bidder = 'Bidder',
    Agent = 'Agent',
    Investor = 'Investor',
  }

  export enum LocalStorageKeys {
    GeoInterest = 'geoInterest',
    MarketingEmail = 'sendMarketingEmail',
    TextMessages = 'receiveTexts',
  }
  /********************************
   *  END EXTENDS NSWAG
   ********************************/

  export const USER_TYPE_NAME: { [key in Models.UserType]: string } = {
    [Models.UserType.Agent]: 'Agent',
    [Models.UserType.Bidder]: 'Bidder',
    [Models.UserType.Client]: 'Client',
    [Models.UserType.Investor]: 'Investor',
  };

  export class ValidationPatterns {
    public static readonly PASSWORD =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  }
}
